import React from 'react';
import { connect } from 'react-redux';
import moment from "moment/moment";

import Translate from 'translate';
import AsyncTable from 'components/HTMLElements/Table/AsyncTable/';
import BroadcastService from "services/BroadcastService";
import { toggleLoading } from 'stores/actions';
import LogDetail from 'routes/app/components/Broadcast/LogDetail';

class NetworksList extends React.Component {
  constructor( props ) {
    super( props );

    this.state = {
      data: [],
      logDetailModalOpened: false,
    };
    this.logEntity = {};
  }

  getLogs = ( params, cb ) => {
    const { toggleLoading } = this.props;
    this.paramsLogs = params;

    toggleLoading( true );

    const apiParams = {
      limit: params.pageSize,
      offset: ( params.page * params.pageSize ),
    };
    if( params.sorted.length ) apiParams[`sortby[${params.sorted[0].id}]`] = params.sorted[0].desc ? 'DESC' : 'ASC';
    else apiParams[`sortby[createdAt]`] = 'DESC';

    BroadcastService.getBroadcasts( apiParams ).then( ( response ) => {
      if( cb ) return cb( response.errors, response.data );
      toggleLoading( false );

      if( response.data ) {
        this.setState( {
          data: response.data.data || [],
          pages: Math.ceil( response.data.total / params.pageSize ),
          total: response.data.total,
        } );
      }
    } )
  };

  toggleLogDetailModal = ( item ) => {
    this.logEntity = item;
    this.setState( { logDetailModalOpened: !this.state.logDetailModalOpened } )
  };

  render() {
    const { data, logDetailModalOpened, ...rest } = this.state;

    return (
      <div>
        <div className="box box-default">
          <div className="box-header">
            <span className="text-capitalize"><Translate id="publishedBroadcast"/></span>
          </div>

          <div className="box-body">
            <AsyncTable className="app-table-white"
                        onFetchData={this.getLogs}
                        rowsText="Logs"
                        data={data}
                        {...rest}
                        columns={[
                          { Header: <Translate id="socialNetwork"/>, accessor: 'socialNetwork.type' },
                          {
                            Header: <Translate id="agent"/>, accessor: 'agent',
                            Cell: props => props.value ? `${props.value.name || ''} ${props.value.lastname || ''}` : ''
                          },
                          {
                            Header: <Translate id="createdAt"/>, accessor: 'createdAt',
                            Cell: props => moment( props.value ).format( 'DD/MM/YYYY hh:mm A' )
                          },
                          {
                            Header: <Translate id="content"/>, accessor: 'content',
                            Cell: props => props.value && props.value.length > 30
                              ? props.value.slice( 0, 30 ) + '...' : props.value
                          },
                        ]}
                        getTdProps={( state, rowInfo ) => {
                          return {
                            onClick: ( e, handleOriginal ) => {
                              this.toggleLogDetailModal( rowInfo.original );
                              if( handleOriginal ) {
                                handleOriginal()
                              }
                            }
                          }
                        }}/>
          </div>
        </div>

        <LogDetail open={logDetailModalOpened}
                   data={this.logEntity}
                   onClose={this.toggleLogDetailModal}
        />
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ( {
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
} );

module.exports = connect(
  null,
  mapDispatchToProps
)( NetworksList );




// WEBPACK FOOTER //
// ./routes/app/routes/broadcast/list/index.js